import { KikCommonUtils } from "@kikocosmeticsorg/uc-api-nest-common-fe";
import { GetServerSidePropsContext, InferGetServerSidePropsType } from "next";
import { useTranslations } from "next-intl";

import Container from "~/components/common/container";
import Grid from "~/components/common/grid";
import LinkWrapper from "~/components/common/link-wrapper";
import CustomerCare from "~/components/customer-care/customer-care";
import GuestReturnYourOrder from "~/components/guest-track-your-order/guest-return-your-order";
import LayoutPage from "~/components/layout/layout-page";
import SendMagicLink from "~/components/send-magic-link/send-magic-link";
import { useConfiguration } from "~/contexts/configuration";
import { usePageTracking } from "~/contexts/page-trackings";
import { SignalRAction } from "~/shared/signalr-action.enum";
import styles from "~/styles/pages/sign-up.module.scss";
import appRoutes from "~/utils/app-routes";
import ssrUtils from "~/utils/ssr-utils";

type Props = InferGetServerSidePropsType<typeof getServerSideProps>;

export default function RequestReturnPage(props: Props) {
  const t = useTranslations();
  usePageTracking("request-a-return");
  const { configuration } = useConfiguration();

  return (
    <LayoutPage {...props} mainClasses={styles.pageBackground} navColor="white" hidePrefooter>
      <Container>
        <Grid>
          <div className={styles.containerSignUp}>
            {KikCommonUtils.parseBoolean(configuration["App:Ecommerce:EnableCustomGuestTrackOrder"]) ? (
              <GuestReturnYourOrder></GuestReturnYourOrder>
            ) : (
              <SendMagicLink
                title={props.page?.title || ""}
                desc={t("generic.returndesc")}
                desc2={t.rich("generic.returndesc2", {
                  link: (content) => <LinkWrapper href={appRoutes.MYACCOUNT}>{content}</LinkWrapper>,
                })}
                isRequestReturn={false}
                submit={t("generic.form.returnsubmit")}
                action={SignalRAction.RETRIEVE_ORDER}
              />
            )}
          </div>
          <div className={styles.containerCustomerCare}>
            <CustomerCare />
          </div>
        </Grid>
      </Container>
    </LayoutPage>
  );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
  if (context.locale === context.defaultLocale) {
    return {
      notFound: true,
    };
  }

  const data = await ssrUtils.getServerSideRequestReturneData(context);
  return {
    props: {
      ...data,
    },
  };
}
